import { Injectable } from '@angular/core';
import {
  SwUpdate,
  // VersionReadyEvent 
} from '@angular/service-worker';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { AppService } from './app.service';
import { AppInstallService } from './app-install.service';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerUpdateService {
  public promptEvent;
  public displayInstall = false;

  constructor(
    private swUpdate: SwUpdate,
    public snackBar: MatSnackBar,
    private utilService: UtilService,
    private appInstallService: AppInstallService) {
    this.appInstallService.pwaInstallSupported = true;
    if (this.utilService.isChrome() || this.utilService.isOpera()) {
      this.appInstallService.pwaInstallSupported = true;
    } else {
      this.appInstallService.pwaInstallSupported = false;
    }
    window.addEventListener('beforeinstallprompt', event => {
      console.log("beforeinstallprompt", event);
      this.displayInstall = true;
      this.appInstallService.setPWAInstalled(false);
      event.preventDefault();
      this.promptEvent = event;
    });
    window.addEventListener('appinstalled', (evt) => {
      console.log("appinstalled");
      this.displayInstall = false;
      this.appInstallService.setPWAInstalled(true);
    });
  }

  init() {
    if (!AppService.isSoftware()) {
      console.log("swUpdate");
      this.swUpdate.versionUpdates.subscribe(evt => {
        switch (evt.type) {
          case 'VERSION_DETECTED':
            console.log(`Downloading new app version: ${evt.version.hash}`);
            break;
          case 'VERSION_READY':
            console.log(`Current app version: ${evt.currentVersion.hash}`);
            console.log(`New app version ready for use: ${evt.latestVersion.hash}`);

            const updateData = evt.latestVersion.appData;
            if (!updateData || !updateData['shouldShowPopup']) {
              return;
            }

            let updateText = 'Reload to get update';
            let updateButtonText = 'Reload';

            console.log('updateData: ', updateData);
            if (updateData !== undefined && updateData['updateText']) {
              updateText = updateData['updateText'];
            }

            if (updateData !== undefined && updateData['updateButtonText']) {
              updateButtonText = updateData['updateButtonText'];
            }

            const snackBarRef = this.snackBar.open(updateText, updateButtonText);

            snackBarRef.afterDismissed().subscribe(() => {
              if (AppService.isAndroid() || AppService.isIOS()) {
                window.location.replace("./index.html");
              } else {
                console.log('window.location.reload')
                window.location.reload();
              }
            });

            break;
          case 'VERSION_INSTALLATION_FAILED':
            console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
            break;
        }
      });
    }
  }

  getPWADisplayMode() {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if (document.referrer.startsWith('android-app://')) {
      return 'twa';
    } else if (isStandalone) {
      return 'standalone';
    }
    return 'browser';
  }
}
